module.exports = __webpack_public_path__ + "static/media/28.d14881d7.png";